export default "__VITE_ASSET__9yQVc64w__"